import Button from './Button'
import Heading from './Heading'
import Input from './Input'
import Link from './Link'
import Select from './Select'
import Tab from './Tab'
import Text from './Text'

export default {
  Heading,
  Text,
  Tab,
  Link,
  Input,
  Button,
  Select
}
